<template>
  <div>
    <span>
      <small>{{ dateText }}</small>
    </span>
    <span v-on:mouseup="sendUpdate">
      <vs-slider color="dark" :step="step" :step-decimals="true" v-model="dateRange" style="width: 80px" />
    </span>
  </div>
</template>

<script>
import is from 'is_js'

export default {
  name: 'DateSliderFilter',
  data: () => ({
    dates: [],
    dateRange: [0, 100],
    max: 0,
    step: 1,
    prevStart: '',
    prevEnd: ''
  }),
  computed: {
    dateText() {
      return `${this.getFirstDate()} to ${this.getSecondDate()}`
    }
  },
  created() {
    this.dates = this.getDaysArray(new Date('2020-03-01'), new Date())
    this.max = this.dates.length - 1
    this.step = 100 / this.max // * 30
  },
  methods: {
    sendUpdate() {
      const start = this.getFirstDate(false)
      const end = this.getSecondDate(false)
      if (this.prevStart !== start || this.prevEnd !== end) {
        this.$emit('updated', {
          start,
          end
        })
        this.prevStart = start
        this.prevEnd = end
      }
    },
    getDay(tick) {
      if (tick === 0 || tick === 100) return tick === 0 ? this.dates[tick] : this.dates[this.max]
      const idx = Math.round((tick * this.max) / 100)
      return this.dates[idx]
    },
    getDaysArray(start, end) {
      // eslint-disable-next-line no-var
      for (var arr = [], dt = new Date(start); dt <= new Date(end); dt.setDate(dt.getDate() + 1)) {
        arr.push(new Date(dt))
      }
      return arr
    },
    getFirstDate(nice = true) {
      return this.getDateText(this.getDay(this.dateRange[0]), nice)
    },
    getSecondDate(nice = true) {
      return this.getDateText(this.getDay(this.dateRange[1]), nice)
    },
    getDateText(d, nice = true) {
      if (is.undefined(d)) return ''
      if (nice) {
        return Intl.DateTimeFormat(navigator.language, { year: 'numeric', month: 'short', day: 'numeric' }).format(d)
      }
      return d.toISOString().slice(0, 10)
    }
  }
}
</script>

<style></style>
